















import { api } from '@/plugins/api';
import { invite } from './api';
import { inviteOther } from "@/api/accident/edit";
import {
  defineComponent,
  reactive,
  Ref,
  ref,
  getCurrentInstance,
  computed
} from '@vue/composition-api';
import store from '@/store';
import groupby from 'lodash.groupby';

export default defineComponent({
  name: 'UserTree',
  props:{
    inviteRole:{
      type: String,
      default:()=>"TrafficPolice"
    }
  },
  setup(props, { emit }) {
    const list: Ref<any[]> = ref([]);
    const loading = ref(false);
    console.log('角色'+props.inviteRole);
    let InviteName = ref('');
    let invitRole = ref('');
    let extensionId = ref('');
    const accidentId:any = (getCurrentInstance() as any).proxy.$root.$route && (getCurrentInstance() as any).proxy.$root.$route.params.id;
    const videoType:any = computed(()=>{
      return (store.state as any).app.videoType;
    }) 
    const videoPhone:any = computed(()=>{
      return (store.state as any).app.videoPhone;
    }) 
    const Msg = (getCurrentInstance() as any).proxy.$root.$message;
    const loadData = async () => {
      loading.value = true;
      const data = await api.video.trtc.onlineUsers.getOnlineUsers.r();
      let groups = groupby(data, it => it.roleName);
      let newGroups = {};
      Object.keys(groups).forEach(key => {
        let arr:any = [];
        groups[key].map((el:any)=> {
            let hasId = false;
            if (key ==='保险员') {
              // 保险员只需要在线的
              if (el.onLine) {
                arr.length && arr.forEach((item:any)=>{
                  if (el.userId === item.userId) {
                    hasId = true;
                  }
                });
                if (!hasId) {
                  arr.push(el);
                }
              }
            }else {
              // 交警全部显示
              arr.length && arr.forEach((item:any)=>{
                if (el.userId === item.userId) {
                  hasId = true;
                }
              });
              if (!hasId) {
                arr.push(el);
              }
            }
        });
        if (key) {
          newGroups[key] = arr;
        }
      });
      list.value = Object.keys(newGroups).map(key => ({
        label: `${key}（${newGroups[key].length}）`,
        value: key,
        type: 'group',
        children: newGroups[key].map((it, index) => ({
          label: it.userName,
          value: it.userName,
          type: 'user',
          isOnline: it.onLine,
          roleName: it.roleName,
          extension: it.extension,
          index
        }))
      }));
      list.value = list.value.find(el => {
        if (props.inviteRole==='Insurance') {
          return el.value === '保险员'
        }else if(props.inviteRole==='TrafficPolice') {
          return el.value === '交警'
        }
      }).children;
      loading.value = false;
      
    };
    // console.log(list);
    const invitReq = (data) => {
      // if (data.roleName === invitRole.value) {
      //   Msg.error(`已邀请过${invitRole.value}！`);
      // }else {
        if (videoType.value) {
          extensionId.value = data.extension;
          inviteOther({phoneNumber: videoPhone.value, inviteService: extensionId.value, accidentId:accidentId}).then(res=>{
            console.log('邀请其他人：' + res);
            if (res.code === 200) {
              Msg.success('邀请成功');
              InviteName.value = data.value;
              invitRole.value = data.roleName;
            }
          })
        }else {
          invite(data.value, accidentId).then(res => {
            Msg.success('邀请成功');
            InviteName.value = data.value;
            invitRole.value = data.roleName;
          }).catch(err => {
            Msg.error('邀请失败');
          });
        }

        
      // }
      
    }
    return {
      list,
      loadData,
      loading,
      invitReq,
      InviteName,
      invitRole,
      accidentId
    };
  }
});
